import {FC, useState, useEffect, Fragment} from 'react'

import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
const api = new Api()

type Props = {
  showAlertModal: boolean
  handleCloseAlertModal: any
  type: string
  title: string
  desc: string
  handleToPage: any
  dataPana: any
  buttonText: string
}

const AlertContent: FC<Props> = ({
  showAlertModal,
  handleCloseAlertModal,
  type,
  title,
  desc,
  handleToPage,
  dataPana,
  buttonText,
}) => {
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState<any>(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setShowModal(showAlertModal)
  }, [showAlertModal])

  const handleClose = () => {
    setShowModal(false)
    handleCloseAlertModal()
  }

  const deletePana = () => {
    setLoading(true)
    api
      .deletePana({
        id_pendaftaran_pana: dataPana?.id,
      })
      .then((response: any) => {
        setLoading(false)
        const {data} = response.data

        if (type == 'delete') {
          localStorage.setItem('currentStep', '1')
          handleToPage('register')
          return
        }

        navigate('/pana-beranda')
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response

        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  const registerPana = () => {
    setLoading(true)
    api
      .registerPana({
        step: 0,
      })
      .then((response: any) => {
        setLoading(false)
        const {data} = response.data
        localStorage.setItem('currentStep', '2')
        handleToPage('register')
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response

        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  const handleOk = () => {
    if (type == 'resubmit') {
      registerPana()
      return
    }

    deletePana()
  }

  return (
    <Modal show={showModal} centered size='sm'>
      <div className='p-10 mt-8'>
        <p className='h6 text-center'>{title}</p>

        <p className='mt-3'>{desc}</p>

        <button
          className='btn btn-primary btn-sm w-100 mt-15'
          style={{background: 'var(--Primary-L-500, #F95E2F)'}}
          onClick={handleOk}
          disabled={loading}
        >
          {loading == true ? 'Loading...' : buttonText}
        </button>

        <button
          className='btn btn-sm w-100 mt-3 text-primary'
          style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
          onClick={handleClose}
          disabled={loading}
        >
          Batal
        </button>
      </div>
    </Modal>
  )
}

const AlertModal: FC<Props> = ({
  showAlertModal,
  handleCloseAlertModal,
  type,
  title,
  desc,
  handleToPage,
  dataPana,
  buttonText,
}) => {
  return (
    <AlertContent
      showAlertModal={showAlertModal}
      handleCloseAlertModal={handleCloseAlertModal}
      type={type}
      title={title}
      desc={desc}
      handleToPage={handleToPage}
      dataPana={dataPana}
      buttonText={buttonText}
    />
  )
}

export default AlertModal
